export default __webpack_public_path__ + "media/images/twitter-f963dcac51d5020e10f30ef102b9141d.png";